module.exports = __webpack_public_path__ + "img/cmp-dp.30c6b8ea.svg";